import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, ShieldCheck, AlertTriangle, ArrowRight } from "lucide-react";
import { useBooking } from "@/context/BookingContext";
import { fmtDateTime } from "@/lib/datetime";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PrivateBooking() {
  const { token } = useParams();
  const { openApproved } = useBooking();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API}/reservations/link/${token}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e.response?.data?.detail || "This booking link is invalid."));
  }, [token]);

  if (error) return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div data-testid="private-link-error" className="max-w-md text-center">
        <AlertTriangle size={44} className="text-red-400 mx-auto mb-4" />
        <h1 className="font-display font-black text-2xl text-white">Link Not Available</h1>
        <p className="text-white/60 mt-3 text-sm">{error}</p>
      </div>
    </div>
  );

  if (!data) return <div className="min-h-screen bg-black flex items-center justify-center text-white/50"><Loader2 className="animate-spin mr-2" size={18} /> Checking your approval…</div>;

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div data-testid="private-booking-page" className="max-w-md text-center">
        <ShieldCheck size={48} className="text-green-400 mx-auto mb-4" />
        <h1 className="font-display font-black text-3xl text-white">You're Approved{data.prefill?.name ? `, ${data.prefill.name.split(" ")[0]}` : ""}!</h1>
        <p className="text-white/60 mt-3 text-sm leading-relaxed">Complete your documents, coverage selection, rental agreement, and payment below. Your vehicle is not fully confirmed until all steps and payment are completed.</p>
        {data.conditions?.length > 0 && (
          <div data-testid="approval-conditions" className="mt-4 bg-[#F2B705]/10 border border-[#F2B705]/30 rounded-md p-4 text-left">
            <div className="text-[#F2B705] font-semibold text-sm mb-1.5">Conditions of your approval:</div>
            <ul className="text-white/70 text-xs space-y-1 list-disc pl-4">{data.conditions.map((c, i) => <li key={i}>{c}</li>)}</ul>
          </div>
        )}
        {data.expires_at && <p className="text-white/40 text-xs mt-3">This link expires {fmtDateTime(data.expires_at)}.</p>}
        <button data-testid="continue-to-booking-btn" onClick={() => openApproved(data.prefill, token)}
          className="mt-6 inline-flex items-center gap-2 px-8 py-3 rounded-md bg-[#F2B705] text-black font-bold">
          Continue to Booking <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}
